const rangeSlider = document.getElementById('price-range-slider');

if (rangeSlider !== null) {
    const filterFrom = document.getElementById('criteria_price_lower');
    const filterTo = document.getElementById('criteria_price_upper');
    const rangeMin = Number(filterFrom.getAttribute('data-lower'));
    const rangeMax = Number(filterTo.getAttribute('data-upper'));

    if (rangeMin !== rangeMax) {
        const noUiSlider = require('nouislider');
        const rangeSliderFromValue = document.getElementById('price-range-slider-from');
        const rangeSliderToValue = document.getElementById('price-range-slider-to');

        noUiSlider.create(rangeSlider, {
            start: [Number(filterFrom.value), Number(filterTo.value)],
            connect: true, // true - shows bar between 2 handles
            margin: 1, // minimum distance between 2 handles
            behaviour: 'drag', // drags by step
            step: 1,
            range: {
                min: Number(filterFrom.getAttribute('data-lower')),
                max: Number(filterTo.getAttribute('data-upper'))
            }
        });

        // Update slider input values.
        rangeSlider.noUiSlider.on('update', function(values, handle) {
            const value = values[handle];
            if (handle) {
                rangeSliderToValue.value = value;
            } else {
                rangeSliderFromValue.value = value;
            }
        });

        rangeSlider.noUiSlider.on('set', function(values, handle) {
            filterFrom.value = rangeSliderFromValue.value;
            filterTo.value = rangeSliderToValue.value;
        });
    }
}
